import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { removeNotification } from '../../store/teamSlice';
import './NotificationToast.css';

const NotificationToast: React.FC = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.team.notifications) || [];

  // Auto-remove notifications after 4 seconds
  useEffect(() => {
    if (notifications && notifications.length > 0) {
      notifications.forEach(notification => {
        const timer = setTimeout(() => {
          dispatch(removeNotification(notification.id));
        }, 4000);

        return () => clearTimeout(timer);
      });
    }
  }, [notifications, dispatch]);

  const handleClose = (id: string) => {
    dispatch(removeNotification(id));
  };

  if (!notifications || notifications.length === 0) return null;

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`notification-toast notification-${notification.type}`}
        >
          <div className="notification-content">
            <span className="notification-icon">
              {notification.type === 'error' && '❌'}
              {notification.type === 'success' && '✅'}
              {notification.type === 'warning' && '⚠️'}
            </span>
            <span className="notification-message">{notification.message}</span>
          </div>
          <button
            className="notification-close"
            onClick={() => handleClose(notification.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationToast; 